import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import { t } from 'i18next';
import React from 'react';
import { Bar } from 'react-chartjs-2';

import {
  CardTitleAndSubtitleContainer,
  WeeklyActivityTitleContainer,
} from '../../components/DashboardCards/cardStyles';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import { DashboardCardTitle } from '../../styledComponents/dashboard';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const TicketCountByTypeChart = ({ data, isLoading }) => {
  if (isLoading || !data) {
    return <ComponentCircleLoader padding="10vh" />;
  }

  // Format data for chart
  const labels = data.task_types.map(type => type.name);
  const counts = data.task_types.map(type => type.count);

  const chartData = {
    labels,
    datasets: [
      {
        label: '', // Removed 'Ticket Count' label
        data: counts,
        backgroundColor: [
          'rgba(255, 99, 132, 0.7)',
          'rgba(54, 162, 235, 0.7)',
          'rgba(255, 206, 86, 0.7)',
          'rgba(75, 192, 192, 0.7)',
          'rgba(153, 102, 255, 0.7)',
          'rgba(255, 159, 64, 0.7)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide the legend completely
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.raw}`; // Just show the value without label
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
        grid: {
          drawBorder: true,
        },
      },
      x: {
        grid: {
          display: false, // Remove vertical grid lines
        },
      },
    },
    barThickness: 'flex', // Allow flexible width
    maxBarThickness: 30, // Set maximum bar width to 20px
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <WeeklyActivityTitleContainer margin="0 0 10px 0" padding="0">
        <CardTitleAndSubtitleContainer>
          <DashboardCardTitle>
            {t('ticket_overview_by_issue_type')}
          </DashboardCardTitle>
          {data.total_count && (
            <div
              style={{ fontSize: '0.8rem', color: '#777', marginTop: '5px' }}
            >
              {t('total')}: {data.total_count} {t('tickets')}
            </div>
          )}
        </CardTitleAndSubtitleContainer>
      </WeeklyActivityTitleContainer>
      <div style={{ height: '300px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default TicketCountByTypeChart;
